<template>
  <div>
    <div class="all-content">
      <!-- 头部 -->
      <!-- 中间 -->
      <!-- <div class="content">
        <div class="first-left">
          <div class="first-img-all">
            <img :src="img" alt class="first-img" :onerror="defaultImg" />
            <div class="first-title">{{ title }}</div>
          </div>
        </div>
        <div class="first-right">
          <div class="top-hot">热点专题</div>
          <div
            class="top-hot-content"
            v-for="(item, index) in imgList"
            :key="index"
          >
            <ul>
              <li
                class="list-one"
                @mouseover="backChangeFirst(item, index)"
                ref="listOne"
                :style="changeBackColor[index]"
              >
                <div class="right-text">
                  <span>{{ item.addTime }}</span>
                  <div>{{ item.title }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <!-- 尾部 -->
      <div class="listwrapper" v-if="list.length">
        <div class="foot" v-for="(item, index) in list" :key="index">
          <div class="foot-one">
            <router-link
              v-if="!item.link"
              :to="{
                name: '详情页面',
                query: {
                  id: item.id,
                  name: $route.name,
                },
              }"
              >{{ item.title }}</router-link
            >
            <a :href="item.link" v-else>
              {{ item.title }}
            </a>
          </div>
        </div>
      </div>
      <div v-else class="emptybox">暂无数据</div>
      <el-pagination
        background
        :page="page"
        :size="size"
        layout="prev, pager, next,jumper"
        :page-count="allSize"
        v-if="allSize"
        @current-change="changePage"
        class="page"
      ></el-pagination>
    </div>

    <div v-if="!allSize" style="height: 100px"></div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  props: {
    classifyId: Number,
    type: Number,
    names: String,
  },
  data() {
    return {
      defaultImg:
        'this.src="' + require('../../static/image/home/img1.jpg') + '"',
      imgId: 0,
      page: 1,
      size: 15,
      allSize: 0,
      list: [],
      imgList: [],
      img: '',
      changeBackColor: [
        { backgroundImage: `url(${require('../assets/img/list08.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
      ],
      changeBackground: [
        { backgroundImage: `url(${require('../assets/img/list08.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list08.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list08.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list08.jpg')})` },
      ],
      changeBackColorAgain: [
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
        { backgroundImage: `url(${require('../assets/img/list09.jpg')})` },
      ],

      title: '',
    };
  },
  methods: {
    // goDetails() {
    //   console.log(this.imgId);
    //   this.$router
    //     .push({
    //       path: '/pageDetails',
    //       query: {
    //         id: this.imgId,
    //         name: this.names,
    //       },
    //     })
    //     .catch((r) => r);
    // },
    // goDetails1(item) {
    //   if (item.link == null || item.link == '') {
    //     // this.$emit('returnId', item.id);
    //     this.$router
    //       .push({
    //         name: '详情页面',
    //         query: {
    //           id: item.id,
    //           name: this.$route.name,
    //         },
    //       })
    //       .catch((r) => r);
    //   } else {
    //     location.href = item.link;
    //   }
    // },
    //1鼠标悬浮上去
    backChangeFirst(item, index) {
      this.img = item.url;
      this.title = item.title;
      this.imgId = item.id;
      this.changeBackColor[index].backgroundImage =
        this.changeBackground[index].backgroundImage;
      for (let i = 0; i < this.changeBackColor.length; i++) {
        if (index != i) {
          this.changeBackColor[i].backgroundImage =
            this.changeBackColorAgain[i].backgroundImage;
        }
      }
    },
    //轮播图下方的新闻接口
    getNewsList() {
      lib
        .appInformationList({
          params: {
            page: this.page,
            size: this.size,
            classifyId: this.classifyId,
          },
        })
        .then((res) => {
          // console.log('res:', res);
          this.list = res.data.records;
          console.log('轮播图下方新闻：', this.list);
          this.allSize = parseInt(res.data.pages);
          // for (let i = 0; i < this.list.length; i++) {
          //   if (this.list[i].content !== '' && this.list[i].content !== null) {
          //     this.list[i].content = this.list[i].content
          //       .replace(/<\/?(img)[^>]*>/gi, '')
          //       .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
          //       .replace(/<br\/?>/gi, '\n')
          //       .replace(/<[^>/]+>/g, '')
          //       .replace(/(\n)?<\/([^>]+)>/g, '')
          //       .replace(/\u00a0/g, ' ')
          //       .replace(/&nbsp;/g, ' ')
          //       .replace(/<\/?(img)[^>]*>/gi, '')
          //       .replace(/&amp;/g, '&')
          //       .replace(/&lt;/g, '<')
          //       .replace(/&gt;/g, '>')
          //       .replace(/&#39;/g, "'")
          //       .replace(/&quot;/g, '"')
          //       .replace(/<\/?.+?>/g, '');
          //   }
          // }

          // lib
          //   .portalbanner({
          //     params: {
          //       type: this.type
          //     }
          //   })
          //   .then(res => {
          //     console.log('00', res);
          //     if (res.code == 2000) {
          //       this.imgList = res.data;
          //       if (this.imgList.length != 0) {
          //         this.img = this.imgList[0].url;
          //         this.title = this.imgList[0].title;
          //         console.log('imgList', this.imgList);
          //         this.imgId = this.imgList[0].id;
          //       }
          //     }
          //   });
        });
    },
    //分页
    changePage(val) {
      // console.log('分页：',val)
      this.page = val;
    if (this.$route.path == '/OnlineSearch') {
      this.getSearch();
    } else {
    this.getNewsList();
    }

      // lib
      //   .appInformationList({
      //     params: {
      //       page: val,
      //       size: 10,
      //       classifyId: this.classifyId
      //     }
      //   })
      //   .then(res => {
      //     this.list = res.data.records;
      //     for (let i = 0; i < this.list.length; i++) {
      //       // console.log(this.list[i].content)
      //       if (this.list[i].content !== '' && this.list[i].content !== null) {
      //         this.list[i].content = this.list[i].content
      //           .replace(/<\/?(img)[^>]*>/gi, '')
      //           .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
      //           .replace(/<br\/?>/gi, '\n')
      //           .replace(/<[^>/]+>/g, '')
      //           .replace(/(\n)?<\/([^>]+)>/g, '')
      //           .replace(/\u00a0/g, ' ')
      //           .replace(/&nbsp;/g, ' ')
      //           .replace(/<\/?(img)[^>]*>/gi, '')
      //           .replace(/&amp;/g, '&')
      //           .replace(/&lt;/g, '<')
      //           .replace(/&gt;/g, '>')
      //           .replace(/&#39;/g, "'")
      //           .replace(/&quot;/g, '"')
      //           .replace(/<\/?.+?>/g, '');
      //       }
      //     }
      //     // console.log(this.list);
      //   });
    },
    
    getSearch() {
      // this.dataparams.title = this.$route.query.title;
      lib
        .searchList({
          params: {
            
            page: this.page,
            size: this.size,
            title:this.$route.query.title
          }
        })
        .then(r => {
          // console.log('搜索数据', r);
          this.list = r.data.records;
          this.allSize = parseInt(r.data.pages);
          // for (let i = 0; i < this.list.length; i++) {
          //   // console.log(this.list[i].content)
          //   if (this.list[i].content !== '' && this.list[i].content !== null) {
          //     this.list[i].content = this.list[i].content
          //       .replace(/<\/?(img)[^>]*>/gi, '')
          //       .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
          //       .replace(/<br\/?>/gi, '\n')
          //       .replace(/<[^>/]+>/g, '')
          //       .replace(/(\n)?<\/([^>]+)>/g, '')
          //       .replace(/\u00a0/g, ' ')
          //       .replace(/&nbsp;/g, ' ')
          //       .replace(/<\/?(img)[^>]*>/gi, '')
          //       .replace(/&amp;/g, '&')
          //       .replace(/&lt;/g, '<')
          //       .replace(/&gt;/g, '>')
          //       .replace(/&#39;/g, "'")
          //       .replace(/&quot;/g, '"')
          //       .replace(/<\/?.+?>/g, '')
          //       .replace(/&ldquo/g, '')
          //       .replace(/&rdquo/g, '');
          //     this.list[i].content = this.list[i].content.slice(0, 150);
          //   }
          // }
        });
    }
  },
  
  mounted() {
    // 轮播图下方的新闻接口
    
    if (this.$route.path == '/OnlineSearch') {
      this.getSearch();
    } else {
    this.getNewsList();
    }
  },
};
</script>
<style scoped lang="scss">
.emptybox{
  text-align: center;line-height: 2em;
}
.listwrapper {
  &>:nth-of-type(5n){
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  }
}
a {
  text-decoration: none;
  color: inherit;
}
a:hover {
  color: #015293;
}
.foot-one {
  font-size: 16px;
  line-height: 2.6em;
  color: #222;
  position: relative;
  padding-left: 10px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    background-color: #bbbbbb;
    top: 50%;
    margin-top: -2px;
    left: 0px;
  }
}
.all-content {
  box-sizing: border-box;
  width: 1100px;
  margin: 0 auto;
  margin-top: 24px;
  border: 1px solid #eeeeee;
  padding: 10px 24px 20px;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);

  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}
.content {
  margin-top: 20px;
  position: relative;
  width: 1100px;
  height: 440px;
}
.first-img:hover {
  transition: transform 2s ease 0s;
  transform: scale(1.4);
}
.first-img {
  width: 640px;
  height: 426px;
  overflow: hidden;
}
.first-img-all {
  position: relative;
  height: 426px;
  width: 640px;
  overflow: hidden;
  display: inline-block;
}
.first-title {
  background-image: url(../assets/img/bg2.png);
  width: 592px;
  position: absolute;
  bottom: 0px;
  color: white;
  font-size: 18px;
  line-height: 32px;
  padding: 8px 24px 16px 24px;
  overflow: hidden;
  height: 52px;
  display: flex;
  align-items: center;
}
.first-left {
  display: inline-block;
  overflow: hidden;
  width: 640px;
}
.first-right {
  background-color: rgb(245, 245, 245);
  width: 430px;
  /* display: inline-block; */
  float: right;
  height: 40px;
}
.first-right-all {
  width: 430px;
  /* display: inline-block; */
  float: right;
}
.top-hot {
  background-color: rgb(1, 82, 147);
  width: 100px;
  color: white;
  height: 40px;
  line-height: 40px;
  font-weight: bolder;
  font-size: 20px;
  text-align: center;
}
.top-hot-content {
  background-image: url(../assets/img/list07.jpg);

  background-repeat: repeat-y;
  margin-bottom: -20px;
}
.top-hot-content ul li {
  list-style: none;
  cursor: pointer;
  height: 95px;
}
.list-one {
  /* background-image: url(../assets/img/list09.jpg); */
  background-repeat: no-repeat;
  background-position: left;
  margin-left: -41px;
  padding-left: 30px;
}

.list-one span {
  color: #9e9e9e;
  font-size: 14px;
}
.list-one p {
  color: #015293;
  font-size: 16px;
  margin-top: 5px;
}
/* .foot {
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  margin-top: 10px;
} */
.all-foot-imfg {
  width: 220px;
  margin-right: 20px;
  overflow: hidden;
  display: inline-block;
}
.foot-img {
  width: 220px;

  vertical-align: top;
  display: inline-block;
}
.foot-img:hover {
  transition: transform 2s ease 0s;
  transform: scale(1.4);
}
.foot-right {
  /* display: inline-block; */
  width: 850px;
  /* height: 200px; */
  float: right;
  /* margin-top: 50px; */
}
.foot-right h3 {
  font-size: 20px;
}
.foot-right p {
  /* float: left; */
  width: 100%;
  font-size: 16px;
  color: #888888;
  line-height: 20px;
  margin-top: 0px;
  height: 60px;
  /* 超出三行用省略号显示 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.foot-right span {
  /* float: left; */
  font-size: 14px;
  color: #c5c5c5;
  margin-right: 25px;
  padding-left: 17px;
}
.time {
  background: url(../../static/img/list10.jpg) no-repeat 0 center;
}
.view {
  background: url(../../static/img/list11.jpg) no-repeat 0 center;
}

.foot-right a {
  text-decoration: none;
  color: black;
}
.right-text {
  position: relative;
  top: 25px;
}
.page {
  margin-top: 20px;
  position: relative;
  display: flex;
  justify-content: center;
}
.foot {
  width: 100%;
  display: flex;
  /* align-items: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/FirstComponent.vue